export const NEW_CALENDAR_MODES = {
  CALENDAR: 'calendar',
  LIST: 'list',
};

export const NEW_CALENDAR_PERIODS = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
};

export const NEW_CALENDAR_VIEWS = {
  [NEW_CALENDAR_MODES.CALENDAR]: {
    [NEW_CALENDAR_PERIODS.MONTH]: 'dayGridMonth',
    [NEW_CALENDAR_PERIODS.WEEK]: 'timeGridWeek',
    [NEW_CALENDAR_PERIODS.DAY]: 'timeGridDay',
  },
  [NEW_CALENDAR_MODES.LIST]: {
    [NEW_CALENDAR_PERIODS.MONTH]: 'listMonth',
    [NEW_CALENDAR_PERIODS.WEEK]: 'listWeek',
    [NEW_CALENDAR_PERIODS.DAY]: 'listDay',
  },
};

export const DEFAULT_NEW_CALENDAR_MODE = NEW_CALENDAR_MODES.CALENDAR;
export const DEFAULT_NEW_CALENDAR_PERIOD = NEW_CALENDAR_PERIODS.WEEK;

export const NEW_CALENDAR_HEADER_TOOLBAR = false;

export const NEW_CALENDAR_TIME_RANGE = {
  min: '07:00:00',
  max: '23:00:00',
};

export const NEW_CALENDAR_SIZING = {
  expandRows: true,
  handleWindowResize: true,
  stickyHeaderDates: true,
  windowResizeDelay: 120,
};

export const NEW_CALENDAR_EVENT_LIMITS = {
  [NEW_CALENDAR_PERIODS.MONTH]: 3,
  [NEW_CALENDAR_PERIODS.WEEK]: 4,
  [NEW_CALENDAR_PERIODS.DAY]: 4,
};

export const NEW_CALENDAR_VIEW_OPTIONS = {
  [NEW_CALENDAR_VIEWS[NEW_CALENDAR_MODES.CALENDAR][NEW_CALENDAR_PERIODS.MONTH]]: {
    dayMaxEvents: NEW_CALENDAR_EVENT_LIMITS[NEW_CALENDAR_PERIODS.MONTH],
    dayHeaderFormat: { weekday: 'long' },
  },
  [NEW_CALENDAR_VIEWS[NEW_CALENDAR_MODES.CALENDAR][NEW_CALENDAR_PERIODS.WEEK]]: {
    slotDuration: '00:30:00',
  },
  [NEW_CALENDAR_VIEWS[NEW_CALENDAR_MODES.CALENDAR][NEW_CALENDAR_PERIODS.DAY]]: {
    slotDuration: '00:30:00',
  },
};
